var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protal-layout"},[_c('div',{staticClass:"protal-layout-header"},[_c('protal-header')],1),(_vm.columnsInfo.length > 0)?_c('div',{staticClass:"protal-layout-content"},[_c('router-view')],1):_vm._e(),_c('div',{staticClass:"protal-layout-footer"},[_c('protal-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }